enum TotalSlideIndex {
  First = 'first',
  Second = 'second',
  Third = 'third',
  Fourth = 'fourth',
}

export default TotalSlideIndex;
